import {ExtraLinkApiModel} from "./extra-link.api-model";
import {BaseDomainModel} from "../../../../../infrastructure/models/base-domain-model";
import {EXTRA_LINKS_CONTEXTS} from "../../../../../core/app/consts";

export class ExtraLinkDomainModel extends BaseDomainModel {
  apiModel: ExtraLinkApiModel;

  get context(): EXTRA_LINKS_CONTEXTS {
    return this.apiModel.context;
  }

  get link(): String {
    return this.apiModel.link;
  }
}